import { showAlert } from "../Store/Actions/GeneralActions";



export const CurrentLocation = {
    getLiveLocation : () =>{
        return (dispatch) => {
            return new Promise(async (resolve, reject) => {
                try {
                    if (!navigator.geolocation) {
                        dispatch(
                          showAlert({
                            type: "Error",
                            message: "Geolocation is not supported by your browser",
                          })
                        );
                      } else {
                        navigator.geolocation.getCurrentPosition(
                          (position) => {
                            let getCords = {
                              latitude: position.coords.latitude,
                              longitude: position.coords.longitude,
                            };
                            resolve(getCords);
                          },
                          () => {
                            dispatch(
                              showAlert({
                                type: "Error",
                                message:
                                  "Unable to retrieve your location . Please Enable your location.",
                              })
                            );
                          }
                        );
                      }
                } catch (error) {
                    reject('err', error);
                }
            })
        }
    }
}

 